import {
  getMenu,
  getRoleList,
  pathCreateRole,
  pathDeleteRole,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { roleActions } from "../reducers/role";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchRoleList = (id_role = 0) => {
  return (dispatch) => {
    return apiService
      .get(getRoleList(id_role))
      .then((response) => {
        id_role == 0
          ? dispatch(roleActions.fetchRoleList(response.data))
          : dispatch(roleActions.fetchRoleDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchMenuList = (id_role = 0) => {
  return (dispatch) => {
    return apiService
      .get(getMenu())
      .then((response) => {
        dispatch(roleActions.fetchMenuList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewRole = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateRole(), data)
      .then((response) => {
        // dispatch(roleActions.fetchRoleList(response.data));
        navigate("/role-list");
        toast.success(t("rolesListActions.created"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditRole = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateRole(), data)
      .then((response) => {
        // dispatch(roleActions.fetchRoleList(response.data));
        navigate("/role-list");
        toast.success(t("rolesListActions.updated"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteRole = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteRole(id))
      .then((response) => {
        toast.success(t("rolesListActions.deleted"), {
          theme: "colored",
        });
        dispatch(fetchRoleList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
